module.exports = __webpack_public_path__ + "img/mj1.364aa97c.png";